<template>
  <div class="video-page">
    <el-card class="mt20">
      <div class="f-right border-b">
        <div class="flex1">$store.state.user.company.cCompanyNum</div>

        <div class="flex1"></div>
        <!-- <el-button icon="el-icon-search" type="primary" @click="showdia2 = true"
          >搜索</el-button
        > -->
        <el-button
          v-hasPermi="['wenwu:program:add']"
          icon="el-icon-plus"
          type="primary"
          @click="showdia = true"
          >新增</el-button
        >
      </div>
      <el-table :data="list" class="">
        <el-table-column prop="num" label="序号" align="center">
        </el-table-column>

        <el-table-column prop="name" align="center" label="项目名称">
        </el-table-column>

        <el-table-column prop="starttime" align="center" label="创建时间">
        </el-table-column>

        <el-table-column prop="newtime" align="center" label="最新报告上传时间">
        </el-table-column>

        <!-- <el-table-column align="center" label="文件上传">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="add(scope.row, 1)"
              >文件上传</el-button
            >
          </template>
        </el-table-column> -->
        <el-table-column label="操作" align="center" width="160px">
          <template slot-scope="scope">
            <router-link
              :to="{
                path: '/report/detail-proList',
                query: { id: scope.row.uuid },
              }"
              v-hasPermi="['wenwu:program:detail']"
            >
              <el-button type="primary" size="mini" plain>详情</el-button>
            </router-link>

            <el-popconfirm
              title="确定执行此操作吗？"
              class="cursor"
              @onConfirm="changeStatus(scope.row)"
              @confirm="changeStatus(scope.row)"
              v-hasPermi="['wenwu:program:remove']"
            >
              <a slot="reference">
                <el-button type="danger" size="mini">删除</el-button>
              </a>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        background
        class="mt20 tx-center"
        @current-change="handleCurrentChange"
        :current-page.sync="params.page"
        :page-size="10"
        layout="prev, pager, next, jumper"
        :total="count"
      >
      </el-pagination>
    </el-card>

    <el-dialog title="编辑项目" :visible.sync="showdia">
      <el-form
        ref="form"
        :model="editData"
        label-width="100px"
        size="small"
        class="flex1"
      >
        <el-form-item
          label="项目名称"
          prop="name"
          :rules="{ message: '请填写/选择', trigger: 'blur', required: true }"
        >
          <el-input v-model="editData.name" clearable></el-input>
        </el-form-item>
        <!-- <el-form-item label="所属集团" prop="company_uuid"  :rules="{ message: '请填写/选择', trigger: 'blur', required: true }">
              <el-select
                v-model="editData.company_uuid"
                filterable
                remote
                placeholder="请输入关键词"
              >
                <el-option
                  v-for="item in compList"
                  :key="item.c_company_num"
                  :label="item.c_name"
                  :value="item.c_company_num"
                ></el-option>
              </el-select>
            </el-form-item> -->
      </el-form>
      <div class="center">
        <el-button
          :loading="btnload"
          type="primary"
          @click="addCommit"
          size="small"
          >提交</el-button
        >
        <el-button @click="showdia = false" size="small">取消</el-button>
      </div>
    </el-dialog>
    <!--  
 <el-dialog title="搜索" :visible.sync="showdia2">
      <el-form label-width="100px" size="small" class="flex1">
            <el-form-item label="单位名称">
          <el-input v-model="searchForm.tr_name" clearable></el-input>
        </el-form-item>
          
        
      </el-form>
      <div class="center">
        <el-button
          type="primary"
          @click="editVideo(null)"
          size="small"
          :loading="isUpload"
          >提交</el-button
        >
        <el-button @click="showEdit = false" size="small">取消</el-button>
      </div>
    </el-dialog> -->
    <!-- <unit v-show="false" ref="unit" isson="1"></unit> -->
  </div>
</template>

<script>
// import {
//   getList,
//   getDetail,
//   add,
//   edit,
//   getVideo,
//   editVideo,
// } from "../../api/media.js";
// import {
//   getUser,
//   getLaw,
//   getRandom,
//   getSociety,
//   getUnit,
// } from "../../api/common";
// import OSS from "ali-oss";
// import unit from "../system/society";
export default {
  data() {
    return {
      editData: {
        name: "",
        company_uuid: this.$store.state.user.company.cCompanyNum,
      },
      btnload: false,
      count: 0,
      showdia: false,
      params: {
        page: 1,
        name: "",
      },
      list: [],
      isEdit: 0,
      canEditLength: false,
    };
  },
  created() {
    this.getList();
    //  this.$post("/dzda/allbase").then((res) => {
    //   this.compList = res.data;
    // });
  },
  methods: {
    resetSearch() {
      this.params.page = 1;
      this.searchForm = {
        tr_project_name: "",
        tr_unit: "",
        tr_type: "",
      };
      this.params = { ...this.params, ...this.searchForm };
      this.getList();
    },

    //修改 删除
    changeStatus(it, st) {
      if (st) {
        this.$set(this, "editData", it);
        this.editData = {
          company_uuid: this.$store.state.user.company.cCompanyNum,
          ...it,
        };
        this.isEdit = 1;
        this.showdia = true;
      } else {
        this.$post("/dzda/delxiangmu", { uuid: it.uuid }).then((res) => {
          if (res.code == 200) {
            // this.$message.success(res.msg || "操作成功");
            this.$message({
                message: res.msg || '操作成功',
                type: 'success',
                duration: 700,
              });
            this.getList();
          }
        });
      }
    },

    getList() {
      this.loading = true;
      this.$post("/dzda/listxiangmu", this.params).then((res) => {
        this.list = res.data.list;
        this.count = res.data.count;
      });
    },

    // 添加

    addCommit(status) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.btnload = true;

          var url = this.isEdit ? "/dzda/updatexiangmu" : "/dzda/addxiangmu";
          this.$post(url, this.editData).then((res) => {
            if (res.code == 200) {
              // this.$message.success(res.msg || "操作成功");
              this.$message({
                message: res.msg || '操作成功',
                type: 'success',
                duration: 700,
              });
              this.showdia = false;
              this.btnload = false;
            }
          });
        }
      });
    },

    handleCurrentChange1(page) {
      this.video_params.page = page;
      this.getVideoData();
    },

    handleCurrentChange(page) {
      this.params.page = page;
      this.getList();
    },
    searchSubmit() {
      this.editData = {
        name: "",
        company_uuid: this.$store.state.user.company.cCompanyNum,
      };
      this.getList();
    },
  },
  watch: {
    showdia(val) {
      if (!val) {
        this.searchSubmit();
        this.isEdit = 0;
        this.btnload = false;
      }
    },
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.file-list {
  li {
    position: relative;
    padding: 20px 10px;
    border-bottom: 1px solid #eee;

    img {
      width: 75px;
      margin-right: 15px;
    }

    .el-icon-close {
      position: absolute;
      right: 20px;
      top: 8px;
      cursor: pointer;
    }
  }
}

.mb5 {
  margin-bottom: 5px;
}

.ml20 {
  margin-left: 20px;
}
.mt10 {
  margin-top: 10px !important;
}
</style>
